import { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';

export default function MarketPlaceComponentPage(): ReactElement {
  const navigate = useNavigate();
  const currentParams = window.location.pathname;
  const menuItems = [
    {
      label: 'Home',
      icon: 'pi pi-fw pi-home',
      command: () => {
        document.body.classList.remove('button-generator');
        navigate('/');
      },
    },
    {
      label: 'Buy Now Button',
      icon: 'pi pi-fw pi-credit-card',
      pathname: '/button-generator',
      command: () => {
        navigate('/button-generator');
      },
    },
    {
      label: 'Cart Icon',
      icon: 'pi pi-fw pi-shopping-cart',
      pathname: '/cart-icon-generator',
      command: () => {
        navigate('/cart-icon-generator');
      },
    },
  ];

  const [activeIndex, setActiveIndex] = useState(
    menuItems.findIndex(item => item.pathname === currentParams),
  );
  useEffect(() => {
    if (currentParams === '/vendor-tools' || activeIndex === -1) {
      setActiveIndex(1);
    }
  }, [activeIndex, currentParams]);

  return (
    <>
      <TabMenu
        className="flex justify-content-center m-3 "
        model={menuItems}
        activeIndex={activeIndex}
        onTabChange={e => setActiveIndex(e.index)}
      />
    </>
  );
}
